const server = __DEV__
  ? 'http://localhost:8200/api/v1'
  : 'https://api.saas-plat.com/v1';

export default {
  version : server + '/app/version',
  dev : server + '/app/dev'
};



// WEBPACK FOOTER //
// ./config.js